// guestTypeActions.js
import {
  fetchGuestTypes as apiFetchGuestTypes,
  addGuestType as apiAddGuestType,
  updateGuestType as apiUpdateGuestType,
  deleteGuestType as apiDeleteGuestType,
} from "../../api/guestType"; // Adjust path accordingly

// Action Types
export const FETCH_GUEST_TYPE_REQUEST = "FETCH_GUEST_TYPE_REQUEST";
export const FETCH_GUEST_TYPE_SUCCESS = "FETCH_GUEST_TYPE_SUCCESS";
export const FETCH_GUEST_TYPE_FAILURE = "FETCH_GUEST_TYPE_FAILURE";
export const ADD_GUEST_TYPE_REQUEST = "ADD_GUEST_TYPE_REQUEST";
export const ADD_GUEST_TYPE_SUCCESS = "ADD_GUEST_TYPE_SUCCESS";
export const ADD_GUEST_TYPE_FAILURE = "ADD_GUEST_TYPE_FAILURE";
export const UPDATE_GUEST_TYPE_REQUEST = "UPDATE_GUEST_TYPE_REQUEST";
export const UPDATE_GUEST_TYPE_SUCCESS = "UPDATE_GUEST_TYPE_SUCCESS";
export const UPDATE_GUEST_TYPE_FAILURE = "UPDATE_GUEST_TYPE_FAILURE";
export const DELETE_GUEST_TYPE_REQUEST = "DELETE_GUEST_TYPE_REQUEST";
export const DELETE_GUEST_TYPE_SUCCESS = "DELETE_GUEST_TYPE_SUCCESS";
export const DELETE_GUEST_TYPE_FAILURE = "DELETE_GUEST_TYPE_FAILURE";

// Action Creators
export const fetchGuestTypeRequest = () => ({ type: FETCH_GUEST_TYPE_REQUEST });
export const fetchGuestTypeSuccess = (types) => ({
  type: FETCH_GUEST_TYPE_SUCCESS,
  payload: types,
});
export const fetchGuestTypeFailure = (error) => ({
  type: FETCH_GUEST_TYPE_FAILURE,
  payload: error,
});
export const addGuestTypeRequest = () => ({ type: ADD_GUEST_TYPE_REQUEST });
export const addGuestTypeSuccess = (type) => ({
  type: ADD_GUEST_TYPE_SUCCESS,
  payload: type,
});
export const addGuestTypeFailure = (error) => ({
  type: ADD_GUEST_TYPE_FAILURE,
  payload: error,
});
export const updateGuestTypeRequest = () => ({
  type: UPDATE_GUEST_TYPE_REQUEST,
});
export const updateGuestTypeSuccess = (type) => ({
  type: UPDATE_GUEST_TYPE_SUCCESS,
  payload: type,
});
export const updateGuestTypeFailure = (error) => ({
  type: UPDATE_GUEST_TYPE_FAILURE,
  payload: error,
});
export const deleteGuestTypeRequest = () => ({
  type: DELETE_GUEST_TYPE_REQUEST,
});
export const deleteGuestTypeSuccess = (id) => ({
  type: DELETE_GUEST_TYPE_SUCCESS,
  payload: id,
});
export const deleteGuestTypeFailure = (error) => ({
  type: DELETE_GUEST_TYPE_FAILURE,
  payload: error,
});

// Thunks
export const fetchGuestType = () => async (dispatch) => {
  dispatch(fetchGuestTypeRequest());
  try {
    const types = await apiFetchGuestTypes();
    dispatch(fetchGuestTypeSuccess(types.result));
  } catch (error) {
    dispatch(fetchGuestTypeFailure(error.message));
  }
};

export const addGuestType = (type) => async (dispatch) => {
  dispatch(addGuestTypeRequest());
  try {
    const newType = await apiAddGuestType(type);
    dispatch(addGuestTypeSuccess(newType));
  } catch (error) {
    dispatch(addGuestTypeFailure(error.message));
  }
};

export const updateGuestType = (type) => async (dispatch) => {
  dispatch(updateGuestTypeRequest());
  try {
    const updatedType = await apiUpdateGuestType({...type });
    dispatch(updateGuestTypeSuccess(updatedType));
  } catch (error) {
    dispatch(updateGuestTypeFailure(error.message));
  }
};

export const deleteGuestType = (id) => async (dispatch) => {
  dispatch(deleteGuestTypeRequest());
  try {
    await apiDeleteGuestType(id);
    dispatch(deleteGuestTypeSuccess(id));
  } catch (error) {
    dispatch(deleteGuestTypeFailure(error.message));
  }
};
